<template>
  <div v-if="toggled" class="action--modal" @click.self="emitToggle">
    <form class="tile action-form" @submit.prevent="submit">
      <p class="content__heading">New User</p>
      <label class="action-form--label" for="user-name">
        Name:
        <input
          type="text"
          id="user-name"
          name="user-name"
          v-model="form.name"
          placeholder="First Last"
          :class="{'input--error': error.name}"
        />
      </label>
      <label class="action-form--label" for="email">
        Email:
        <span v-if="emailMsg" class="text__red text__small">{{ emailMsg }}</span>
        <input
          type="email"
          id="email"
          name="email"
          v-model="form.email"
          placeholder="person@fbhl.com"
          :class="{'input--error': error.email}"
        />
      </label>
      <label class="action-form--label" for="admin">
        Is Admin:
        <select
          id="admin"
          name="admin"
          v-model="form.isAdmin"
          :class="{'input--error': error.isAdmin}"
        >
          <option :value="false">No</option>
          <option :value="true">Yes</option>
        </select>
      </label>
      <div class="flex__between">
        <span class="text__bold text__red" @click.prevent="emitToggle">Cancel</span>
        <button class="btn btn__small btn__green" @click.prevent="submit">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { VALID_DOMAINS, isValidDomain } from "../../../firebase/auth";
export default {
  props: ["toggled"],
  data() {
    return {
      form: {
        name: "",
        email: "",
        isActive: true,
        isAdmin: false
      },
      error: {
        name: false,
        email: false,
        isAdmin: false
      },
      emailMsg: ""
    };
  },
  methods: {
    ...mapActions(["startCreateUser"]),
    emitToggle() {
      this.$emit("setNewToggled");
      this.error.name = false;
      this.error.email = false;
      this.error.isAdmin = false;
      return this.resetForm();
    },
    resetForm() {
      this.form.name = "";
      this.form.email = "";
      this.form.isAdmin = false;
    },
    async submit() {
      this.emailMsg = "";
      const re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      this.form.name === ""
        ? (this.error.name = true)
        : (this.error.name = false);
      this.form.email === ""
        ? (this.error.email = true)
        : (this.error.email = false);
      if (re.test(this.form.email)) {
        this.error.email = false;
      } else {
        this.error.email = true;
        this.emailMsg = "Invalid Email";
        return;
      }
      if (isValidDomain(this.form.email)) {
        this.error.email = false;
      } else {
        this.error.email = true;
        this.emailMsg = `Only ${VALID_DOMAINS.join(
          ", "
        )} domains are permitted`;
        return;
      }
      if (this.error.name || this.error.email) {
        return;
      }
      // submit form
      await this.startCreateUser(this.form);
      this.emitToggle();
    }
  }
};
</script>

<style scoped lang="scss">
</style>